@if(isChecked){
<div class="checkmark ms-2 is-checked">&#10003;</div>
}@else {
@if(showIsNotCheckedIndicator){
<div class="checkmark ms-2">
  <!--    TODO replace with x image from redesign-->
  &#8722;
</div>
}
}